/*
import TOOLTIP from "../../../../constants/artifact_tooltip.constant";
import CONFIG_MESSAGES from "../../../../constants/configuration_messages.constants";
*/
import {default as merge} from 'lodash.merge';

export class AdminAdvancedSupportPageController {
    constructor($timeout, $scope, $window, XRAY_RESOURCE, XRayUIState,User, JFrogNotifications, $compile, JFrogModal, SupportDao, $state, JFrogTableViewOptions, JFrogGridFactory, JFrogEventBus) {
        this.jfrogGridFactory = JFrogGridFactory
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.XRayUIState = XRayUIState
        this.SupportDao = SupportDao;
        this.$compile = $compile;
        this.user = User;
        this.XRAY_RESOURCE = XRAY_RESOURCE;
        this.$state = $state;
        //this.CONFIG_MESSAGES = CONFIG_MESSAGES.admin.advanced.supportZone;
        this.artifactoryNotifications = JFrogNotifications;
        this.modal = JFrogModal;
        this.ready = false;
        this.$window = $window;
        this.timePeriodConfig = {
            maxItems: 1,
            create: false
        };

        this.tableViewOptions = new JFrogTableViewOptions($scope);
        this.listTableViewOptions = new JFrogTableViewOptions($scope);
        this._init();

        this.thread_dump_config = true;
        $scope.$parent.Settings.showButtons = true;
        $scope.$parent.Settings.currentSubController = this;
        $scope.$parent.Settings.saveButtonText = 'Create';
        this.createGrid();

        this.EVENTS = JFrogEventBus.getEventsDefinition();
        let removeUpdateListener = JFrogEventBus.register(this.EVENTS.BUNDLES_REFRESH, () => {
            console.log('REFRESHING BUDNLES...');
            this.getPreviousBundles();
        });

    }



    _init() {
        this.supportPath = "${XRAY_HOME}/xray/support/{DATE_TIME}_{BUNDLE_ID}";
        this.setup = {
            system_info: true,
            artifactory_instances_config: true,
            config_files: true,
            messages_queues: true,
            db_sync_info: true,
            system_logs: {
                include:true
            },
            thread_dump_config: {
                num_of_thread_dumps: 5,
                interval: 1000
            },
            selectedTimeSpan: {text: 'Last 24 hours', value: '24h'}

        };


        this.SupportDao.getEnvInfo().$promise.then((response) => {
            console.log("The Env info is", response);
            let dist = response.distribution;

            if(!dist){
                return;
            }

            if(dist === "docker"){
                this.supportPath = "${XRAY_HOME}/xray/support/{DATE_TIME}_{BUNDLE_ID}";
            }else{
                this.supportPath = "${XRAY_HOME}/xray/data/support/{DATE_TIME}_{BUNDLE_ID}";
            }
        });
        this.setTimePicker();
    }

    save() {

        console.log("SENDING REQUEST FOR SUPPORT SONZE");
        let payload = _.cloneDeep(this.setup)
        console.log("Payload is ", payload);

        _.forEach(payload, (val, key) => {
            if(key == "system_logs" && val.include){
                let isCustom = this.setup.selectedTimeSpan.value.toLowerCase() == "custom"
                if(!isCustom){
                    console.log("assigning date!")
                    val.date = this.setup.selectedTimeSpan.value.toLowerCase()

                }else{
                  val =  merge(val,this.createdCustomTime)
                }
            }
        });

        delete payload.selectedTimeSpan;

        if (!this.thread_dump_config) {
            delete payload.thread_dump_config;
        }

        this.SupportDao.createBundle(payload).$promise.then((response) => {
            console.log("Got Response", response.data);
            if (response.data.download_url) {
                console.log("GOT URL!");
                let token = (this.XRayUIState.getState('sessionData') || {}).token;
                let url = `${response.data.download_url}&token=${token}`;
                console.log("Downlading from", url);
                this.$window.open(url, "_self");
            }

            this.getPreviousBundles();
        });
    }

    getPreviousBundles() {


        this.SupportDao.getPreviousBundles().$promise.then((response) => {
            this.tableViewOptions.setData(response)
        });
    }

    deleteBundle(row) {

        this.modal.confirm(`Are you sure you want to delete this support bundle ('${row.name}') ?`)
            .then(() => {
                this.SupportDao.deleteBundle({}, {bundle_id: row.id}).$promise.then((response) => {
                    this.$timeout(() => {
                        this.getPreviousBundles();
                    }, 500)

                });
            });


    }

    cancel() {
        this.$state.go('home')
    }

    canSave() {

        let cBoxs = _.filter(this.setup, (p) => {
            return p == true
        })

        if (this.thread_dump_config) {
            cBoxs.push(this.thread_dump_config)
        }
        return cBoxs.length > 0 && this.setup.name && this.setup.name !== '' && this.SupportPageForm.$valid;
    }

    createGrid() {
        this.tableViewOptions.setId('policies-table')
            .setObjectName('Support Bundle/Support Bundles')
            .setColumns(this.getColumns())
            .setRowsPerPage(20)
            .setActions(this.getActions())


        this.tableViewOptions.on('row.clicked', (data) => {

        });

        this.tableViewOptions.emptyTableText = 'No support Bundles created.';
        this.getPreviousBundles();
        this.tableViewOptions.sortBy('created_at').reverseSortingDir();


    }

    getColumns() {
        return [
            {
                "header": "Name",
                "field": "id",
                'cellTemplate': `<div class="{{row.entity.priority}}">{{row.entity.name ? row.entity.name  : 'N/A'}}</div>`,
                "filterable": true
            },
            {
                "header": "Description",
                "field": "decription",
                'cellTemplate': `<div >{{row.entity.description}}</div>`,
                "filterable": true
            },
            {
                "header": "Created At",
                "field": "time",
                'cellTemplate': `<div >{{row.entity.time | date:'medium'}}</div>`,
                "filterable": true
            },
            {
                "header": "Status",
                'field': 'status',
                'cellTemplate': `<div> <span ng-if="!row.entity.is_ready">In Progress</span><span ng-if="row.entity.is_ready">Ready</span>  <small> ({{row.entity.counter}}/{{row.entity.expected}})</small></div>`,
                "filterable": true
            }
        ]
    }


    getActions() {
        return [{
            icon: 'icon icon-download',
            tooltip: 'Download',
            callback: (row) => {
//TODO:Add the download bundle function once we have a link
                this.downloadbundle(row)
            },
            visibleWhen: (row)=> row.download_link
        },{
            icon: 'icon icon-info',
            tooltip: 'More Info',
            callback: (row) => {
                console.log('Need to show modal of ', row.nodes_status);

                this.showNodesModal(row)
            }
        },
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => {
                    this.deleteBundle(row)
                }
            }]

    }

    downloadbundle(row){

        console.log("Row",row)
        let token = this.user["XRayUIState"].states.sessionData.token;
        let url = `/ui/system/support/bundle/${row.id}/archive?token=${token}`;
        console.log("Downlading from", url);

        this.$window.open(url, "_self");

    }

    instanceChanged(){

        //TODO:Add an aciton if neccesary in case of instance change via the support zone instance drop down
    }

    showNodesModal(row) {
        let modalScope = this.$scope.$new();
        this.listGridOptions = this.jfrogGridFactory.getGridInstance(modalScope)
            .setRowTemplate('default')
            .setColumns(this._getListColumns())
            .setRowsPerPage(8)
            .setGridData(row.nodes_status);


        modalScope.modalTitle = 'Nodes Status - ' + row.id;
        modalScope.gridOptions = this.listGridOptions;
        this.modal.launchModal('show_list_grid_modal', modalScope).result.then(() => {
        });
    }


    _getListColumns() {
        return [
            {

                displayName: 'Microservice',
                field: 'micro_service',
                cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.ms_name | capitalizeFirst}}</div>`,
                name: 'micro_service',
                width: '33%'
            },
            {
                displayName: 'Node ID',
                field: 'node_id',
                cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.node_id}}</div>`,
                width: '34%'
            },
            {

                displayName: 'Status',
                cellTemplate: ` <div class="ui-grid-cell-contents" >{{row.entity.status | capitalizeFirst}}</div>`,
                field: 'status',
                width: '33%'
            }
        ];
    }
    onChangeTimeSpan() {
        if (this.setup.selectedTimeSpan.value === 'CUSTOM') {
            $('#daterange3').click()
            $('.daterangepicker').appendTo('.comp-filter-type')

        }
    }
    setTimePicker(){

        this.logsTypesTimeSpanOptions = [
            {text: 'Last 24 hours', value: '24h'},
            {text: 'Last 3 Days', value: '3d'},
            {text: 'Last 5 Days', value: '5d'},
            {text: 'Last 7 Days', value: '7d'},
            {text: 'Custom Range', value: 'CUSTOM'}
        ];

        this.datePicker = {startDate: null, endDate: null}
        this.dateRangeOpts = {
            "drops": "up",
            "showDropdowns": true,
            maxDate: new Date(),
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "YYYY-MM-DD",
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            }
            /*ranges: {
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()]
            }*/
        };

        this.$scope.date = {}
        this.$scope.$watch('date', (newDate) => {
            console.log("Triggered",newDate)
            if (newDate.startDate && newDate.endDate) {
                let start_date = new Date(newDate.startDate._d).getTime();
                let end_date = new Date(newDate.endDate._d).getTime();
                this.createdCustomTime = {start_date,end_date} ;
            }
        }, false);
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/support_page/support_page.controller.js